module.exports = __webpack_public_path__ + "images/3911269ace2435650082aa04cf5815b2.png";